module.exports = __webpack_public_path__ + "img/u157.d99b0ca8.svg";